var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "58ECDF81-528C-4AA7-8DC9-D67CF961978A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.4393398,0.939339828 C21.0251263,0.353553391 21.9748737,0.353553391 22.5606602,0.939339828 C23.109835,1.48851461 23.1441584,2.35757702 22.6636304,2.94673776 L22.5606602,3.06066017 L8.81066017,16.8106602 C8.26148539,17.359835 7.39242298,17.3941584 6.80326224,16.9136304 L6.68933983,16.8106602 L0.439339828,10.5606602 C-0.146446609,9.97487373 -0.146446609,9.02512627 0.439339828,8.43933983 C0.988514613,7.89016504 1.85757702,7.85584162 2.44673776,8.33636956 L2.56066017,8.43933983 L7.75,13.629 L20.4393398,0.939339828 Z",
    id: "success-tick-path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success-tick-PB-PARENT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success-tick-08-ui-P-success-msg-v1",
    transform: "translate(-153.000000, -251.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success-tick-tick",
    transform: "translate(153.000000, 251.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "success-tick-Oval",
    stroke: "#00875A",
    fill: "#E2FFEE",
    cx: 35,
    cy: 35,
    r: 34.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "success-tick-postIcons/outlines/ic_tick-L",
    transform: "translate(23.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "success-tick-Path",
    opacity: 0.376544331,
    points: "0 0 24.0000001 0 24.0000001 24.0000001 0 24.0000001"
  }), /*#__PURE__*/React.createElement("g", {
    id: "success-tick-colours/neutral/N100",
    transform: "translate(0.500000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "success-tick-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#success-tick-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "success-tick-Mask",
    fill: "#C1C7D0",
    fillRule: "nonzero",
    xlinkHref: "#success-tick-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#success-tick-mask-2)",
    fill: "#00875A",
    id: "success-tick-colours/secondary/G400"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.000000, -52.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success_tick.c33bb33f6e684b9acdaa279ec0c70139.svg";
export { ForwardRef as ReactComponent };